<!-- @migration-task Error while migrating Svelte code: $$props is used together with named props in a way that cannot be automatically migrated. -->
<script lang="ts">
    import { Slot, SLOT_TYPES } from "../../model/Slot";
    import type { BaseProps } from "../BaseProps";
    import Asset3DViewer from "../components/Asset3DViewer.svelte";
    import BootstrapVectorIcon from "../components/BootstrapVectorIcon.svelte";
    import LoadingSpinner from "../components/LoadingSpinner.svelte";

    let {
        slot = undefined,
        assetUrl = undefined,
        classes,
        style
    }
    : BaseProps & {
        slot: Slot,
        assetUrl: string
    } = $props();
    let dimensionFactorXtoY = slot.type == SLOT_TYPES.TEXTURE ? (slot.dimensions[1] / slot.dimensions[0]) * 100 : 1;
</script>

<div class=" {classes}"  style="{style || ""}">
    <div class="card mb-0">
        <div
            class="img-placeholder-block"
            style="{ slot.type == SLOT_TYPES.TEXTURE ? "padding-top: " + dimensionFactorXtoY + "%;"  : "" }"
        >
            {#if assetUrl}
                {#if slot.type == SLOT_TYPES.TEXTURE}
                    <img src={assetUrl} class="rounded figure-img" alt="..." />    
                {:else if slot.type == SLOT_TYPES.OBJECT_3D}
                    <Asset3DViewer url={assetUrl} height="500px" />
                {:else}
                    Error -- unknown slot type
                {/if}
                

            {:else}
                <div class="position-absolute top-50 start-50 translate-middle">
                    <LoadingSpinner
                        style="height: 4em; width: 4em;"
                        loaded={false}
                    ></LoadingSpinner>
                </div>
            {/if}
        </div>
    </div>
</div>
